import { render, staticRenderFns } from "./WhatsAppOfficialAccount.modal.vue?vue&type=template&id=2089fa81&scoped=true&"
import script from "./WhatsAppOfficialAccount.modal.vue?vue&type=script&lang=js&"
export * from "./WhatsAppOfficialAccount.modal.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppOfficialAccount.modal.vue?vue&type=style&index=0&id=2089fa81&prod&lang=scss&scoped=true&"
import style1 from "./WhatsAppOfficialAccount.modal.vue?vue&type=style&index=1&id=2089fa81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089fa81",
  null
  
)

export default component.exports